<base-modal-component (onConfirm)="save()" [validation]="isValid()" class="base-modal">
    <fields-list-component [fields]="fields" [value]="mealplan" name="mealplans"></fields-list-component>
</base-modal-component>
